// extracted by mini-css-extract-plugin
module.exports = {"advanced-wrapper":"page-wrapper_advanced-wrapper__drSjf","search-column":"page-wrapper_search-column__TYLgT"};